module.exports = math;


//////////////////
// WEBPACK FOOTER
// external "math"
// module id = 6194
// module chunks = 